import { useEffect, useRef } from "react";
import { useMotionValue, useSpring } from "framer-motion";
import PropTypes from 'prop-types'
import { NAME_SOUND_POINTS_COUNT, useGameSounds } from "@educaplay/core";

export function AnimatingNumber({ value, decimals = 3, className, delay=0 }) {
    const nodeRef = useRef();
    const gameSound = useGameSounds();
    const motionValue = useMotionValue(0);
    const springValue = useSpring(motionValue, {
        damping: 170,
        stiffness: 170,
        mass: .75,
        
    });

    useEffect(() => {
        const initialPoints = 0;
        nodeRef.current.textContent = initialPoints.toFixed(decimals);
        const timeOut = setTimeout(() => {
            if(value > 0) gameSound.play(NAME_SOUND_POINTS_COUNT);
            motionValue.set(value);
        }, delay);

        return ()=>{
            clearTimeout(timeOut);
        }
        
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value, motionValue, decimals, delay]);

    useEffect(() => {
        const node = nodeRef.current;

        springValue.on("change", (latest) => {
            node.textContent = latest.toFixed(decimals);
        })

        return () => springValue.stop();
    }, [springValue, decimals]);

    return <span className={className} ref={nodeRef} />;
}

AnimatingNumber.propTypes = {
    value: PropTypes.number,
    decimals: PropTypes.number,
    className: PropTypes.string
}